/**
 * @namespace HTML namespace.
 */
Foundation.HTML = window["Foundation"]["HTML"] = {};

/**
 * List of tags that are not allowed to have closing tags.
 * @return {Array}
 */
Foundation.HTML.voidTags = function () {
    return [
        "area", "col", "command", "keygen", "track", "wbr",
        "base", "link", "meta", "br", "hr", "img", "embed", "param", "source",
        "input"
    ];
}
